import AlertComponent from '../../Alert'
import { useTranslation } from 'react-i18next'

const NoResultsMessage = ({ participantsTerminated }) => {
  const i18n = useTranslation()

  if (!participantsTerminated) return null
  if (participantsTerminated < 6) {
    return (
      <AlertComponent message={i18n.t('pages.data.sociogram.activeSociogramEce.noResultsMessage')} type='warning' />
    )
  } else {
    return (
      <AlertComponent message={i18n.t('pages.data.sociogram.activeSociogramEce.errorResultsMessage')} type='error' />
    )
  }
}

export default NoResultsMessage
